"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROJECT_TYPE_OPTIONS = void 0;

var _projectType = require("./projectType");

var _productType = require("./productType");

var PROJECT_TYPE_OPTIONS = [{
  label: 'Video',
  value: _projectType.PROJECT_TYPE.VIDEO,
  product: _productType.PRODUCT_TYPE.PRO,
  iconName: 'video',
  name: 'video'
}, {
  label: 'Podcast',
  value: _projectType.PROJECT_TYPE.PODCAST,
  product: _productType.PRODUCT_TYPE.PRO,
  iconName: 'voiceover',
  name: 'podcast'
}, {
  label: 'Animation',
  value: _projectType.PROJECT_TYPE.ANIMATION,
  product: _productType.PRODUCT_TYPE.PRO,
  iconName: 'publish',
  name: 'animation'
}, {
  label: 'Webinar',
  value: _projectType.PROJECT_TYPE.WEBINAR,
  product: _productType.PRODUCT_TYPE.PRO,
  iconName: 'vodcast',
  name: 'webinar'
}, {
  label: 'Promo',
  value: _projectType.PROJECT_TYPE.PROMO,
  product: _productType.PRODUCT_TYPE.PITCHTEMPLATE,
  iconName: 'mobile',
  // we use a common icon for elevate template types as of now
  name: 'elevate' // we use a common name for elevate template types as of now

}, {
  label: 'Scriptless',
  value: _projectType.PROJECT_TYPE.SCRIPTLESS,
  product: _productType.PRODUCT_TYPE.PITCHTEMPLATE,
  iconName: 'mobile',
  // we use a common icon for elevate template types as of now
  name: 'elevate' // we use a common name for elevate template types as of now

}, {
  label: 'Blank',
  value: _projectType.PROJECT_TYPE.BLANK,
  product: _productType.PRODUCT_TYPE.PITCHTEMPLATE,
  iconName: 'mobile',
  // we use a common icon for elevate template types as of now
  name: 'elevate' // we use a common name for elevate template types as of now

}];
exports.PROJECT_TYPE_OPTIONS = PROJECT_TYPE_OPTIONS;